module.exports = __webpack_public_path__ + "img/taiping.3a69e4d3.png";